/**
 * Creates a deep clone of the given object.
 *
 * This function attempts to use the `structuredClone` method if available,
 * which provides a more robust and efficient way to deep clone objects,
 * including handling circular references and special object types.
 * If `structuredClone` is not available, it falls back to using
 * `JSON.parse(JSON.stringify(obj))`, which works for most plain objects
 * but may not handle certain edge cases (e.g., functions, `undefined`, or
 * circular references).
 *
 * @typeParam T - The type of the object to be cloned.
 * @param obj - The object to deep clone.
 * @returns A deep clone of the input object.
 */
function deepClone(obj) {
    if (obj === undefined) {
        return obj;
    }
    if (typeof structuredClone === 'function') {
        return structuredClone(obj);
    }
    return JSON.parse(JSON.stringify(obj));
}

export { deepClone, deepClone as default };
